// Spots
export { default as Spots } from "./Spots";
export type { default as SpotsProps } from "./SpotsProps.interface";

// Card
export { default as Spot } from "./components/Spot/Spot";
export type { default as SpotProps } from "./components/Spot/SpotProps.interface";